import { Select } from 'antd';
import { DivisionsTypes } from 'shared/enums/substitutions';
import { useAppDispatch } from 'app/store';
import { uiModel } from 'entities/ui';
import { options } from '../config';

enum AddedOption {
  all = 'all',
}

type SelectValue = DivisionsTypes | AddedOption;

export const Filter = () => {
  const dispatch = useAppDispatch();

  const onChange = (value: SelectValue) => {
    if (value === AddedOption.all) {
      dispatch(uiModel.Substitutions.actions.setFilter());
    } else dispatch(uiModel.Substitutions.actions.setFilter(value));
  };

  return <Select options={options} defaultValue={AddedOption.all} onChange={onChange} />;
};
